import { ref, onBeforeUnmount, getCurrentInstance, type Ref } from 'vue';
import { types } from '../../store/types/types';
import { exportingStatus } from '../../../shared/enums/exportingStatus';

const POLLING_RATE = 3000;
export const useDocumentExport = () => {
  const { proxy } = getCurrentInstance() as any;

  const isExporting: Ref<boolean> = ref(false);
  const isExportFailed: Ref<boolean> = ref(false);
  const fileProgress: Ref<number> = ref(0);
  const downloadUrl: Ref<string | null> = ref(null);

  let archiveDocumentTrackingTimer: ReturnType<typeof setInterval> | null = null;

  const stopTracking = (): void => {
    if (archiveDocumentTrackingTimer) {
      clearInterval(archiveDocumentTrackingTimer);
      archiveDocumentTrackingTimer = null;
    }
  };

  const resetState = (): void => {
    isExporting.value = false;
    isExportFailed.value = false;
    fileProgress.value = 0;
    downloadUrl.value = null;

    proxy.$store.commit(types.MUTATE_ARCHIVE_DOCUMENT_TRACK, null);
    proxy.$store.commit(types.MUTATE_ARCHIVE_DOCUMENT_PROGRESS, null);
    stopTracking();
  };

  const startExportDocuments = async (documentIds: number[]): Promise<void> => {
    resetState();
    isExporting.value = true;

    try {
      await proxy.$store.dispatch(types.ACTION_CREATE_ARCHIVE_SECURE_DOCUMENTS, {
        secureDocumentIds: documentIds,
      });

      archiveDocumentTrackingTimer = setInterval(async () => {
        const requestId: string = proxy.$store.getters[types.GET_ARCHIVE_DOCUMENT_TRACK];

        if (!requestId) {
          return;
        }

        try {
          await proxy.$store.dispatch(types.ACTION_TRACK_ARCHIVE_SECURE_DOCUMENTS, { requestId });

          const progressData = proxy.$store.getters[types.GET_ARCHIVE_DOCUMENT_PROGRESS];

          if (progressData) {
            fileProgress.value = progressData.progress * 100;

            if (progressData.status === exportingStatus.COMPLETED) {
              isExporting.value = false;
              downloadUrl.value = progressData.fileUrl;
              stopTracking();
            }
          }
        } catch (error) {
          isExportFailed.value = true;
          isExporting.value = false;
          stopTracking();
        }
      }, POLLING_RATE);
    } catch (error) {
      isExportFailed.value = true;
      isExporting.value = false;
    }
  };

  onBeforeUnmount(() => {
    stopTracking();
  });

  return {
    isExporting,
    isExportFailed,
    fileProgress,
    downloadUrl,
    startExportDocuments,
    resetState,
  };
};
